export type LocalJsonFile = {
  name: string;
  path: string;
  data: any;
};

let cachedFiles: LocalJsonFile[] | null = null;

export function getLocalJsonFiles(): LocalJsonFile[] {
  if (process.env.NODE_ENV !== "development") return [];
  if (cachedFiles) return cachedFiles;

  try {
    const context = require.context("../.local", true, /\.json$/);

    cachedFiles = context.keys().map((key: string) => {
      const mod: any = context(key);
      const data = mod?.default ?? mod;
      const cleanPath = key.replace(/^\.\//, "");
      const name = cleanPath.split("/").pop() || cleanPath;

      return {
        name,
        path: cleanPath,
        data,
      };
    });

    return cachedFiles;
  } catch (error) {
    console.warn("Unable to load local JSON files from src/.local", error);
    return [];
  }
}

export function getLocalJsonFileByPath(path: string): LocalJsonFile | null {
  return getLocalJsonFiles().find((f) => f.path === path) || null;
}